export default "__VITE_ASSET__7cJ4SMUg__"